export default (betKey) => {
  const splitKey = betKey.split(':')
  return splitKey[2]
}
